import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  SelectionDialogComponent, type SelectionDialogProps,
} from './selectionDialog.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    SelectMarkersForOptimizeRoute: SelectionDialogProps;
  }
}

modalRenderer.register('SelectMarkersForOptimizeRoute', SelectionDialogComponent);
